























































































import { Component, Vue } from 'vue-property-decorator'
import adminPanelApi from '@/api/admin-panel'
import {SystemLogATableDto} from "@/global";
import * as enums from '@/global-enum'

@Component({
})
export default class AdminPanel_AdminPanel extends Vue {
    scrollbarSettings = {
        suppressScrollY: true
    };

    table = {
        isLoading: false,
        currentPage: 1,
        totalCount: -1,

        fields: [
            {
                key: 'type',
                label: 'Тип'
            },
            {
                key: 'createdOn',
                label: 'Дата'
            },
            {
                key: 'initiator',
                label: 'Ініціатор'
            },
            {
                key: 'message',
                label: 'Повідомлення'
            },
            {
                key: 'detailsText',
                label: 'Деталі'
            },
        ]
    };

    tableItemsProvider(ctx, callback: (items: SystemLogATableDto[]) => void) {
        this.table.isLoading = true;

        adminPanelApi.systemLogsForTable(this.table.currentPage, result => {
            this.updateDetailsTexts(result.items);

            callback(result.items);

            this.table.totalCount = result.totalCount;
            this.table.isLoading = false;
        }, errorMessage => {
            callback([]);

            this.table.isLoading = false;
        });

        return null;
    }

    getUserDisplayName(log: SystemLogATableDto): string {
        if (this.$helpers.isExists(log)) {
            if (this.$helpers.isNotEmptyArray(log.initiatorAccessTypes)) {
                const adminAccessesString = this.$appUtils.getAdminAccesses(log.initiatorAccessTypes);

                if (this.$helpers.isNotEmpty(adminAccessesString)) {
                    return `(${adminAccessesString}) ${log.initiatorName}`
                }
            }

            return log.initiatorName;
        }

        return ""
    }

    getLogTypeBadgeVariant(log: SystemLogATableDto) {
        if (this.$helpers.isExists(log)) {
            switch (log.type) {
                case enums.AppLogType_Info:
                    return "info";
                case enums.AppLogType_Error:
                    return "danger";
                default:
                    return "primary";
            }
        }
    }

    getLogTypeBadgeText(log: SystemLogATableDto) {
        if (this.$helpers.isExists(log)) {
            switch (log.type) {
                case enums.AppLogType_Info:
                    return "Інфо";
                case enums.AppLogType_Error:
                    return "Помилка";
                default:
                    return "Лог";
            }
        }
    }

    updateDetailsTexts(logs: SystemLogATableDto[]) {
        let detailsText: string;

        for (let i = 0; i < logs.length; i++) {
            const log = logs[i];

            detailsText = "";

            if (this.$helpers.isNotEmpty(log.description)) {
                detailsText += log.description;
            }

            if (this.$helpers.isNotEmptyArray(log.propertyUpdates)) {
                if (this.$helpers.isNotEmpty(log.description)) {
                    detailsText += "\n\n";
                }

                for (let j = 0; j < log.propertyUpdates.length; j++) {
                    const property = log.propertyUpdates[j];

                    const propertyValue = this.$helpers.isNotEmpty(property.oldValue) ? `${property.oldValue} -> ${property.newValue}` : property.newValue;

                    detailsText += `${j === 0 ? "" : "\n"}${property.displayName}=${propertyValue};`;
                }
            }

            log.isDetailsTextShowed = false;
            log.detailsText = detailsText;
            log.detailsTextShort = log.detailsText.slice(0, 200);
        }
    }
}
